import { useEffect } from "react";
import { useQuery } from "@apollo/client/react";
import { GET_ROLES_ONLY } from "@/hooks";
import { enqueueSnackbar } from "notistack";

interface Role {
  id: string;
  role: string;
  key: string;
  createdAt: string;
  updatedAt: string;
  value: string;
  label: string;
}

interface GetRolesOnlyResponse {
  roles?: Role[];
  comRoles?: Role[];
}

interface UseRolesOnlyListReturn {
  rolesList: Role[];
  loading: boolean;
}

/**
 * Custom hook to fetch the list of roles.
 * @param {object} props - The properties to be passed to the query.
 */
export function useRolesOnlyList(
  props?: Record<string, any>,
): UseRolesOnlyListReturn {
  const propsDefault = {};
  const variables = {
    ...propsDefault,
    ...(props || {}),
  };

  const { data, loading, error } = useQuery<GetRolesOnlyResponse>(
    GET_ROLES_ONLY,
    {
      variables,
      errorPolicy: "all",
    },
  );

  // Handle errors with snackbar
  useEffect(() => {
    if (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
    }
  }, [error]);

  return {
    rolesList: data?.roles || data?.comRoles || [],
    loading,
  };
}
